import { CREATE, DELETE, EDIT } from '@/constants/api'

export const MEMBERS = 'members'
export const MEMBER = 'member'

export const ENDPOINTS = {
  CREATE_MEMBER: `/${MEMBERS}/${CREATE}`,
  GET_MEMBERS: `/${MEMBERS}/`,
  GET_MEMBER: `/${MEMBERS}/${MEMBER}`,
  UPDATE_MEMBER: `/${MEMBERS}/${EDIT}`,
  DELETE_MEMBER: `/${MEMBERS}/${DELETE}`,
}
